<script setup>
// Assinatura discreta da Reloadse: rodape das telas de autenticacao e da barra
// lateral (nesta, com `compact`).
//
// Os arquivos vivem em public/brand-assets/reloadse/ e sao servidos estaticos
// pelo Rails. Precisam ir em `:src` (binding) e nao em `src="/..."`: o
// publicDir do Vite e public/vite, entao um src estatico faria o Rollup tentar
// resolver o caminho como modulo e quebrar o build de producao.
const RELOADSE_LOGO_LIGHT =
  '/brand-assets/reloadse/reloadse-horizontal-preto.png';
const RELOADSE_LOGO_DARK =
  '/brand-assets/reloadse/reloadse-horizontal-branco.png';

defineProps({
  compact: { type: Boolean, default: false },
});
</script>

<template>
  <p
    class="flex items-center select-none text-n-slate-10"
    :class="compact ? 'gap-1.5 text-[0.625rem]' : 'gap-2 text-xs'"
  >
    <span>{{ $t('LOGIN.POWERED_BY_RELOADSE') }}</span>
    <a
      href="https://reloadse.com.br"
      target="_blank"
      rel="noopener noreferrer"
      class="inline-flex transition-opacity opacity-70 hover:opacity-100"
    >
      <img
        :src="RELOADSE_LOGO_LIGHT"
        alt="Reloadse"
        class="block w-auto h-4 dark:hidden"
      />
      <img
        :src="RELOADSE_LOGO_DARK"
        alt="Reloadse"
        class="hidden w-auto h-4 dark:block"
      />
    </a>
  </p>
</template>
